module.exports = __webpack_public_path__ + "static/media/fa-brands-400.57dcda6f.eot";